import { Controller } from "@hotwired/stimulus"

// Bulk row selection with dialog confirmation.
//
// Markup:
//   <div data-controller="bulk-select">
//     <input data-bulk-select-target="all" type="checkbox" data-action="bulk-select#toggleAll">
//     <input data-bulk-select-target="row" type="checkbox"
//            value="42" data-name="Alice" data-action="bulk-select#toggleRow">
//     ...
//     <div data-bulk-select-target="toolbar" hidden>
//       <span data-bulk-select-target="count">0</span>
//       <button data-action="bulk-select#open"
//               data-bulk-target-id="bulk-dialog-delete">Excluir</button>
//     </div>
//
//     <!-- Hidden dialog with a form. Stimulus fills hidden ids[] + count/names spans. -->
//     <div id="bulk-dialog-delete">
//       <span data-bulk-dialog-count>0</span>
//       <span data-bulk-dialog-names></span>
//       <form data-bulk-dialog-form>
//         <!-- ids[] inputs appended here -->
//       </form>
//     </div>
//   </div>
export default class extends Controller {
  static targets = ["all", "row", "toolbar", "count"]
  static values  = { moreOthers: { type: String, default: "and %{count} more" } }

  connect() { this.refresh() }

  toggleAll() {
    this.rowTargets.forEach(r => (r.checked = this.allTarget.checked))
    this.refresh()
  }

  toggleRow() {
    this.allTarget.checked = this.rowTargets.every(r => r.checked)
    this.allTarget.indeterminate =
      !this.allTarget.checked && this.rowTargets.some(r => r.checked)
    this.refresh()
  }

  refresh() {
    const selected = this.rowTargets.filter(r => r.checked)
    if (this.hasCountTarget) this.countTarget.textContent = selected.length
    if (this.hasToolbarTarget) this.toolbarTarget.toggleAttribute("hidden", selected.length === 0)
  }

  // Open a dialog by id, populating its hidden form with the current selection
  // and its summary text (count + first 5 names + “+N”).
  open(e) {
    const targetId = e.currentTarget.dataset.bulkTargetId
    const dialog = document.getElementById(targetId)
    if (!dialog) return

    const selected = this.rowTargets.filter(r => r.checked)
    const ids   = selected.map(r => r.value)
    const names = selected.map(r => r.dataset.name || `#${r.value}`)

    // Update count
    dialog.querySelectorAll("[data-bulk-dialog-count]").forEach(el => {
      el.textContent = ids.length
    })

    // Update names list (first 5 + “+N more”). Template comes from i18n via value.
    const namesEl = dialog.querySelector("[data-bulk-dialog-names]")
    if (namesEl) {
      const first = names.slice(0, 5).join(", ")
      const extra = names.length > 5
        ? " " + this.moreOthersValue.replace("%{count}", names.length - 5)
        : ""
      namesEl.textContent = first + extra
    }

    // Replace hidden ids[] inputs inside the form
    const form = dialog.querySelector("[data-bulk-dialog-form]")
    if (form) {
      form.querySelectorAll('input[name="ids[]"]').forEach(n => n.remove())
      ids.forEach(id => {
        const input = document.createElement("input")
        input.type = "hidden"
        input.name = "ids[]"
        input.value = id
        form.appendChild(input)
      })
    }

    // Trigger the dialog open (same convention as data-dialog-trigger)
    document.dispatchEvent(new CustomEvent("click"))
    // Find the dialog controller on the element and call .open() directly.
    const dialogController = this.application.getControllerForElementAndIdentifier(dialog, "dialog")
    if (dialogController) dialogController.open()
  }
}
